// src/components/TableToolbar.jsx
export default function TableToolbar({
  onBack,
  backText = "Regresar",
  searchPlaceholder = "Buscar...",
  searchValue,
  onSearchChange,
  onSearch,
  sizeValue,
  onSizeChange,
  addText = "Agregar",
  showPlus = true,
  onAdd,
  extraRight,
}) {
  return (
    <div className="lmd-toolbar">
      {/* Left: back + search */}
      <div className="lmd-toolbar-left">
        {onBack && (
          <button className="lmd-btn lmd-btn-secondary" onClick={onBack}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            {backText}
          </button>
        )}

        <div className="lmd-search-wrap">
          <span className="lmd-search-icon">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </span>
          <input
            type="text"
            className="lmd-search-input"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(e) => onSearchChange?.(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && onSearch?.()}
          />
          <button className="lmd-search-btn" onClick={onSearch}>
            Buscar
          </button>
        </div>
      </div>

      {/* Right: size + extras + add */}
      <div className="lmd-toolbar-right">
        {sizeValue !== undefined && (
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontSize: 12, color: "var(--clr-text-muted)", whiteSpace: "nowrap" }}>
              Mostrar
            </span>
            <select
              className="lmd-select"
              style={{ width: 70 }}
              value={sizeValue}
              onChange={(e) => onSizeChange?.(Number(e.target.value))}
            >
              {[10, 20, 30, 50, 100].map((n) => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>
        )}

        {extraRight}

        {onAdd && (
          <button className="lmd-btn lmd-btn-primary" onClick={onAdd}>
            {showPlus && (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
            )}
            {addText}
          </button>
        )}
      </div>
    </div>
  );
}
